module.exports = __webpack_public_path__ + "static/media/set_Donas.8c47056e.jpg";